import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { alterarAtivoUsuario, listarUsuarios, logoutMaster } from '../../api/master';
import { useMasterAuth } from '../../context/MasterAuthContext';
import { UsuarioAdmin } from '../../types';

export function AdminUsuarios() {
  const { master, setMaster } = useMasterAuth();
  const [usuarios, setUsuarios] = useState<UsuarioAdmin[]>([]);
  const [carregando, setCarregando] = useState(true);
  const navigate = useNavigate();

  function carregar() {
    setCarregando(true);
    listarUsuarios()
      .then(setUsuarios)
      .finally(() => setCarregando(false));
  }

  useEffect(carregar, []);

  async function handleAlternarAtivo(usuario: UsuarioAdmin) {
    await alterarAtivoUsuario(usuario.id, !usuario.ativo);
    carregar();
  }

  async function handleLogout() {
    await logoutMaster();
    setMaster(null);
    navigate('/master/login');
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      <header
        style={{
          background: '#10203D',
          color: 'var(--cor-branco)',
          padding: '12px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <strong>Lizzi Food — Acesso mestre</strong>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span style={{ fontSize: '14px' }}>{master?.nome}</span>
          <button onClick={handleLogout}>Sair</button>
        </div>
      </header>

      <main style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '20px' }}>Usuários cadastrados</h1>

        {carregando ? (
          <p>Carregando...</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', background: 'var(--cor-branco)', marginTop: '16px' }}>
            <thead>
              <tr style={{ textAlign: 'left', borderBottom: '1px solid var(--cor-borda)' }}>
                <th style={{ padding: '10px' }}>Nome</th>
                <th style={{ padding: '10px' }}>E-mail</th>
                <th style={{ padding: '10px' }}>Empresa</th>
                <th style={{ padding: '10px' }}>Status</th>
                <th style={{ padding: '10px' }}></th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((usuario) => (
                <tr key={usuario.id} style={{ borderBottom: '1px solid var(--cor-borda)' }}>
                  <td style={{ padding: '10px' }}>{usuario.nome}</td>
                  <td style={{ padding: '10px' }}>{usuario.email}</td>
                  <td style={{ padding: '10px' }}>{usuario.tenant_nome}</td>
                  <td style={{ padding: '10px', color: usuario.ativo ? 'var(--cor-sucesso)' : 'var(--cor-erro)' }}>
                    {usuario.ativo ? 'Ativo' : 'Inativo'}
                  </td>
                  <td style={{ padding: '10px' }}>
                    <button onClick={() => handleAlternarAtivo(usuario)}>
                      {usuario.ativo ? 'Desativar' : 'Ativar'}
                    </button>
                  </td>
                </tr>
              ))}
              {usuarios.length === 0 && (
                <tr>
                  <td colSpan={5} style={{ padding: '16px', textAlign: 'center' }}>
                    Nenhum usuário cadastrado ainda.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </main>
    </div>
  );
}
